var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:mail-32-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.33737 9.303C2.38813 8.14469 2.88401 7.05067 3.72162 6.24901C4.55924 5.44735 5.67395 4.99992 6.83337 5H25.8334C26.9928 4.99992 28.1075 5.44735 28.9451 6.24901C29.7827 7.05067 30.2786 8.14469 30.3294 9.303L28.8534 10.123L16.3334 16.864L3.81337 10.123L2.33737 9.303ZM2.33337 11.588V22.5C2.33337 23.6935 2.80748 24.8381 3.65139 25.682C4.49531 26.5259 5.6399 27 6.83337 27H25.8334C27.0268 27 28.1714 26.5259 29.0154 25.682C29.8593 24.8381 30.3334 23.6935 30.3334 22.5V11.588L29.8074 11.881L16.8074 18.881C16.6617 18.9594 16.4988 19.0005 16.3334 19.0005C16.1679 19.0005 16.0051 18.9594 15.8594 18.881L2.84737 11.874L2.33337 11.588Z",
    fill: "#FBBF24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail02);
export default __webpack_public_path__ + "static/media/email_02.a131caad5440feb56403f7d5232b0b2a.svg";
export { ForwardRef as ReactComponent };